import CommissionRelease from '../components/commissionRelease/index';

const masterDistributorRoutes = [
];

export  default masterDistributorRoutes;
